import React from "react"

const SearchResultsPageTitle = ({ query, totalNumberOfResults }: Props) => {
	return (
		<h1>
			Ihre Suche für &quot;{query}&quot; ergab {totalNumberOfResults} Ergebnisse
		</h1>
	)
}

interface Props {
	query: string
	totalNumberOfResults: number
}

export default SearchResultsPageTitle
